<div class="indicator-status">
    <span class="status" [ngSwitch]="status">
        <ng-container *ngSwitchCase="indicatorStatus.NotComplete">
            <div class="notCompleted">
                {{'forms.common.inicatorsNotComplete' | translate}}
                <i class="fa fa-adjust"></i>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="indicatorStatus.Completed">
            <div class="completed">
                {{'forms.common.inicatorsCompleted' | translate}}
                <i class="fa fa-check-circle-o"></i>
            </div>
        </ng-container>
    </span>
</div>